<template>

    <div v-if="track">

        <div class="track-name">
            {{ track.title }}
        </div>

        <div class="track-composer text-stardust-grey">
            Composer: {{ track.composer }}
        </div>

        <div class="form-group">

            <label for="trackFromnameInput">
                Sender Email:
            </label>

            <input class="form-control" id="trackFromnameInput" placeholder="me@example.com" v-model="fromemail" />

        </div>

        <div class="form-group">

            <label for="trackEmailInput">
                Recipient Email (max. 3, comma-separated):
            </label>

            <input class="form-control" id="trackEmailInput" placeholder="recipient@example.com" v-model="email" />

        </div>

        <div class="form-group">

            <label for="emailNotesInput">
                Track Notes:
            </label>

            <textarea class="form-control" id="emailNotesInput" placeholder="Email Notes (optional)" v-model="notes"
                      cols="30" rows="7" />

        </div>


        <a class="btn btn-raised btn-xl font-weight-semibold share-button" v-bind:class="{ 'btn-success': sharing, 'btn-danger': !sharing }" href="#" v-on:click.prevent="emailTrack">
            <span v-if="!sharing">Share</span>
            <span v-if="sharing"><img src="/images/download-spinner.gif" alt="spinner" class="loading-icon">Sharing...</span>
        </a>

        <div class="form-group row">
            <div class="col-12">


                <label><br/><br/> <strong>Or</strong> share using the URL below</label>

                <textarea v-model="copiedTrackDetails" id="trackData" class="d-none"></textarea></div>
            <div class="col-sm-10">
                <input class="form-control" type="text" :value="copiedTrackDetails" readonly />
            </div>
            <div class="col-sm-2 copy-track">
                <a href="#" class="btn btn-primary btn-block btn-sm copy-track-details-button" v-bind:class="{ 'btn-success': copied }"
                   data-clipboard-action="copy" data-clipboard-target="#trackData">
                    <span v-if="!copied">Copy</span>
                    <span v-if="copied">Copied</span>
                </a>
            </div>
        </div>

    </div>

</template>

<script>

  import Vue from 'vue';
  import Clipboard from 'clipboard';
  import { playerService } from '../player-service';

  export default Vue.component( 'share-track', {

    data: function() {

      return {

        track: null,
        notes: null,
        email: null,
        copiedTrackDetails: null,
        clipboardPlugin: null,
        copied: false,
        fromemail: '',
        sharing: false

      };

    },

    mounted: function() {

        let ctx = this;

        playerService.$on( 'user-updated', () => {
            if(window.authenticatedUserEmail){
                this.fromemail = window.authenticatedUserEmail;
            }
        } );

      // Change the edit track contents depending on whats passed to it.
      playerService.$on( 'share-track', ( track ) => {

        // Update curr track for modal.
        this.track = track;

        this.reset();

        // Open the modal.
        window.webpackOpenBsModalWorkaround( '#shareTrackModal' );

          // Setup the contents of the textarea.
          this.copiedTrackDetails = this.getWindowUrl() + '/player?view-shared-track=' + this.track.id;

          if (this.clipboardPlugin) {
              this.clipboardPlugin.destroy();
          }

          this.clipboardPlugin = new Clipboard('.copy-track-details-button', {
              container: document.getElementById('shareTrackModal'),
              text: function (trigger) {
                  return ctx.copiedTrackDetails
              }
          });

          this.copied = false;

          this.sharing = false;

          this.clipboardPlugin.on('success', function (e) {

              ctx.copied = true;

              e.clearSelection();
          });

          if(this.fromemail) {
              setTimeout(function() {
                  $('#trackFromnameInput').attr('readonly', true);
              }, 250);
          }

      } );
    },

    methods: {

      emailTrack: function() {

        this.sharing = true;

        playerService.emailTrack( this.track, this.email, this.notes, this.fromemail );

      },

      reset: function() {

        this.notes = null;
        this.email = null;
        if(window.authenticatedUserEmail){
            this.fromemail = window.authenticatedUserEmail;
        }

      },

        copy: function () {

            this.copied = true;

        },


        getWindowUrl: function () {
            if (!window.location.origin) {
                window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
            }

            return window.location.origin;

        },


    },

    watch: {

      track: function( value ) {

        this.reset();

      },

    },

  } );

</script>
